import { useEffect, useState } from "react";
import { api, money } from "@/lib/api";

const Row = ({ k, v, bold, color }) => (
  <div className="flex justify-between text-sm py-0.5">
    <span className={bold ? "font-bold text-zinc-800" : "text-zinc-500"}>{k}</span>
    <span className={`${bold ? "font-heading font-black" : "font-medium"} ${color || "text-zinc-900"}`}>{v}</span>
  </div>
);

export const ProfitabilityCard = ({ jobId }) => {
  const [p, setP] = useState(null);
  useEffect(() => { api.get(`/jobs/${jobId}/profitability`).then((r) => setP(r.data)).catch(() => {}); }, [jobId]);
  if (!p || (p.gross_revenue <= 0 && p.total_actual_cost <= 0)) return null;
  return (
    <section className="bg-white border border-zinc-200 rounded-2xl p-4" data-testid="profitability-card">
      <h2 className="text-xs tracking-[0.15em] uppercase font-bold text-zinc-400 mb-2">Job Profitability · Internal</h2>
      <Row k="Labor / service revenue" v={money(p.labor_revenue)} />
      <Row k="Material revenue" v={money(p.material_revenue)} />
      <Row k="Other billable" v={money(p.other_billable_revenue)} />
      <div className="border-t border-zinc-100 my-1.5" />
      <Row k="Gross revenue" v={money(p.gross_revenue)} bold />
      <div className="border-t border-zinc-100 my-1.5" />
      <Row k="Actual material cost" v={money(p.material_pretax_cost)} />
      <Row k="Purchase tax" v={money(p.purchase_tax)} />
      <Row k="Other expenses" v={money(p.other_expenses)} />
      <Row k="Total actual cost" v={money(p.total_actual_cost)} bold color="text-red-600" />
      <div className="border-t border-zinc-100 my-1.5" />
      <Row k="Estimated gross profit" v={money(p.gross_profit)} bold color="text-green-600" />
      <div className="flex justify-between items-center mt-1">
        <span className="text-xs text-zinc-500">Gross margin</span>
        <span className="font-heading font-black text-green-600" data-testid="profit-margin">{p.gross_margin_pct}%</span>
      </div>
      <p className="text-[11px] text-zinc-400 mt-2">Internal only — never shown to the customer. Tips are excluded.</p>
    </section>
  );
};
